import React, { useState, useEffect } from 'react';
import { useWebSocket } from './WebSocketContext';
import dataunfoldLogo from '../images/logotransparent.png';

import { useTranslation } from "react-i18next";
import { Box, Typography } from '@mui/material';

const Loading = ({ folder }) => {
  const [loadingValue, setLoadingValue] = useState("");
  const [loadingCode, setLoadingCode] = useState(0);
  const { ws, subscribeToMessages } = useWebSocket();
  const { t } = useTranslation();

  const [loadingGif, setLoadingGif] = useState(dataunfoldLogo);
  const [loadingMsg, setLoadingMsg] = useState("Loading...");
  
  useEffect(() => {
    const unsubscribe = subscribeToMessages((parsedMessage) => {
      // Message is already parsed in WebSocketContext
      if (parsedMessage.command === 'loadingCode') {
        console.log('Code left: ' + parsedMessage.data);
        setLoadingCode(parsedMessage.data);
        switch (parsedMessage.data) {
          case 'EMAILCHECK':
            setLoadingGif(dataunfoldLogo);
            setLoadingMsg("Checking mail...");
            break;
          case 'PREPARE':
            setLoadingGif(dataunfoldLogo);
            setLoadingMsg("Preparing events...");
            break;
          case "LOAD":
            setLoadingGif(dataunfoldLogo);
            setLoadingMsg("Loading events...");
            break;
          default:
            setLoadingGif(dataunfoldLogo);
            setLoadingMsg("Loading...");
        }
      }
      if (parsedMessage.command === 'loadingValue') {
        console.log('File left: ' + parsedMessage.data);
        setLoadingValue(parsedMessage.data);
      }
    });
    return unsubscribe;
  }, [subscribeToMessages]);

  const showFilesLeftText = loadingCode === 'PREPARE' || loadingCode === 'LOAD';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
        padding: 3,
        background: 'transparent'
      }}
    >
      <Box sx={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 3
      }}>
        {/* Loading message */}
        <Typography 
          variant="h6" 
          align="center" 
          sx={{ 
            color: '#5757b0',
            fontWeight: 500,
            animation: 'fadeInOut 2s ease-in-out infinite',
            '@keyframes fadeInOut': {
              '0%, 100%': { opacity: 0.6 },
              '50%': { opacity: 1 }
            }
          }}
        >
          {`${loadingMsg} ${loadingValue}`}
          {showFilesLeftText && ` ${t("loading.files_left")}.`}
        </Typography>
        
        {/* Logo with rotating ring */}
        <Box sx={{ 
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {/* Simple rotating ring */}
          <Box sx={{
            position: 'absolute',
            width: 80,
            height: 80,
            borderRadius: '50%',
            border: '2px solid transparent',
            borderTop: '2px solid #5757b0',
            animation: 'spin 2s linear infinite',
            '@keyframes spin': {
              '0%': { transform: 'rotate(0deg)' },
              '100%': { transform: 'rotate(360deg)' }
            }
          }} />
          
          {/* Logo with simple floating animation */}
          <Box sx={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(255,255,255,0.95)',
            animation: 'float 3s ease-in-out infinite',
            '@keyframes float': {
              '0%, 100%': { transform: 'translateY(0px)' },
              '50%': { transform: 'translateY(-8px)' }
            }
          }}>
            <img 
              src={loadingGif} 
              alt="Loading..." 
              style={{ 
                width: '45px', 
                height: '45px'
              }} 
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Loading;
